import script from "./SummaryEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryEditor.vue?vue&type=script&setup=true&lang=js"

import "./SummaryEditor.vue?vue&type=style&index=0&id=4ebe13cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ebe13cc"]])

export default __exports__